// src/components/FloatingParticles.js
import React, { useRef } from "react";
import { motion } from "framer-motion";
import { v4 as uuidv4 } from "uuid";
import { useStyle } from "../context/StyleContext";
const generateParticles = (count) => {
  const particles = [];
  for (let i = 0; i < count; i++) {
    particles.push({
      id: uuidv4(),
      top: `${Math.random() * 100}vh`,
      left: `${Math.random() * 100}vw`,
      duration: Math.random() * 5 + 5, // duration between 5 and 10 seconds
      size: `${Math.random() * 1 + 0.8}rem`, // size between 0.5rem and 1.5rem
    });
  }
  return particles;
};

const FloatingParticles = ({ count = 100 }) => {
  const particles = useRef(generateParticles(count));
  const styles = useStyle();
  return (
    <div className="fixed top-0 left-0 w-screen h-screen pointer-events-none">
      {particles.current.map((particle) => (
        <motion.div
          key={particle.id}
          className="absolute  rounded-full shadow-lg"
          style={{
            top: particle.top,
            left: particle.left,
            width: particle.size,
            height: particle.size,
            background: `linear-gradient(90deg, black, ${styles.buttonColor})`,
            boxShadow: `0 0 10px ${styles.buttonColor}, 0 0 20px${styles.buttonColor}, 0 0 30px ${styles.buttonColor}`, // add glow
          }}
          animate={{
            y: ["0%", "100%", "0%", "-100%", "0%"],
            x: ["0%", "100%", "0%", "-100%", "0%"],
          }}
          transition={{
            repeat: Infinity,
            duration: particle.duration,
            ease: "easeInOut",
          }}
        />
      ))}
    </div>
  );
};

export default FloatingParticles;
